import styled from 'styled-components/macro';

const GridArea = styled.div<{ area: string }>`
  grid-area: ${({ area }) => area};
`;

export default GridArea;
